import styled from 'styled-components';

import {blue, grey, iPacRed, lightGreen, mediumGrey} from '@components/hoc/Theme/Theme.styled';
import Locker from '../Icon/svg/Locker.svg';
import { isIpac } from '@config/constants';

export const ProgressBarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  padding: 8px;
`;

export const ProgressBarWrapper = styled.div`
  max-width: calc(97% - 100px);
  background-color: ${grey};
  height: 8px;
  border-radius: 8px;
  z-index: 1;
  margin: 0;

  &:before {
    content: 'Formulaire sécurisé';
    position: absolute;
    right: calc(1.5% + 15px);
    transform: translateY(-20%);
    font-family: $textFontThin;
    font-size: 10px;
    color: ${mediumGrey};
  }

  &:after {
    content: "";
    position: absolute;
    right: 1.5%;
    transform: translate(50%, -80%);
    width: 15px;
    height: 15px;
    vertical-align: bottom;
    background: url("${Locker}") no-repeat center center;
    background-size: contain;
  }

  @media (max-width: 768px) {
    max-width: 95%;

    &:after {
      right: 3%
    }

    &:before {
      content: '';
    }
  }
`;

export const ProgressBarFill = styled.div`
  max-width: ${(props) => props.$progress}%;
  height: 8px;
  z-index: 2;
  margin: 0;
  transition: all .3s ease;
  border-radius: 8px;
  background: -webkit-linear-gradient(to right, ${ isIpac ? "#f2c7b3" : lightGreen }, ${ isIpac ? iPacRed : blue });
  background: -moz-linear-gradient(to right, ${ isIpac ? "#f2c7b3" : lightGreen }, ${ isIpac ? iPacRed : blue });
  background: linear-gradient(to right, ${ isIpac ? "#f2c7b3" : lightGreen }, ${ isIpac ? iPacRed : blue });

`;
